const hiddenBusinessMenuCodes = new Set([
  'oms.manage',
  'oms.manage.staff',
  'oms.manage.permission',
  'oms.userInfo'
])

const adminMenuCodes = new Set([
  'oms.manage.staff',
  'oms.manage.permission'
])

function itemCode (item) {
  return item && (item.code || item.meta && item.meta.code)
}

export function isAdminPage (path) {
  return path === '/oms/admin' || (path && path.indexOf('/oms/admin/') === 0)
}

export function shouldShowSidebar (path) {
  return path !== '/userInfo'
}

export function shouldShowTenantShortcut (path) {
  return !isAdminPage(path)
}

export function getSidebarMenu (menu, path) {
  const items = Array.isArray(menu) ? menu : []
  if (isAdminPage(path)) {
    const adminGroup = items.find(item => itemCode(item) === 'oms.manage' || item.path === '/oms/admin')
    if (adminGroup && Array.isArray(adminGroup.children)) {
      return adminGroup.children.filter(item => adminMenuCodes.has(itemCode(item)))
    }
    return items.filter(item => adminMenuCodes.has(itemCode(item)))
  }
  return items.filter(item => item.path !== '/home' && item.path !== '/userInfo' && !hiddenBusinessMenuCodes.has(itemCode(item)))
}

// 按授权菜单顺序寻找首个可访问页面，只有后台权限的账号也能正常进入。
export function getFirstAccessiblePath (menu) {
  const excludedPaths = new Set(['/', '/home', '/userInfo', '/403', '/login', '/oms/admin'])
  const find = (items) => {
    for (const item of Array.isArray(items) ? items : []) {
      if (!item) continue
      const code = itemCode(item)
      if (item.resourceType === 'BUTTON' || String(code || '').startsWith('oms.action.') || code === 'oms.userInfo') continue
      const childPath = find(item.children)
      if (childPath) return childPath
      if (typeof item.path === 'string' && item.path.startsWith('/') && !excludedPaths.has(item.path)
        && (!Array.isArray(item.children) || item.children.length === 0)) return item.path
    }
    return ''
  }
  return find(menu)
}
